import React from "react";
import SpinningShield from "./SpinningShield";

// Two Iron Gate crests layered on the same axis, counter-rotating (one
// clockwise, one counter-clockwise) for a compass / gear-like effect.
const OverlappingShields = ({
  size = 300,
  opacity = 0.08,
  duration = 40,
  className = "",
}) => (
  // NOTE: no hardcoded position class here -- the caller's className is
  // expected to supply the position utility (e.g. "absolute ..."), so it
  // never fights with a default "relative" class for specificity.
  <div
    className={`pointer-events-none select-none ${className}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <SpinningShield
      size={size}
      opacity={opacity}
      duration={duration}
      centered
      className="absolute top-1/2 left-1/2"
    />
    <SpinningShield
      size={size * 0.72}
      opacity={opacity * 0.9}
      duration={Math.max(10, duration * 0.65)}
      reverse
      centered
      className="absolute top-1/2 left-1/2"
    />
  </div>
);

export default OverlappingShields;
